import linkRuleLight from '../../common/algorithms/link-rule-light';

const firstCondition = (ratio) => ratio >= 3.5;
const secondCondition = (ratio) => ratio < 7;

const light = (params) => linkRuleLight(params, { firstCondition, secondCondition });

export default light;
